import axios from "axios";
import { prependUserToSelectNote } from "../../utils/prependUserToSelectNote";
import { User } from "../../contexts/UserContext";
import { InternalUser } from "../../types/app";

export const cleanUserName = (username: string): string => {
  return username.replace("WORKGROUP\\", "");
};

export const createAssignmentNote = (assignedToUser: InternalUser, appUser: User | null): string => {
  const updateAssigneeNote = `Assigned to ${assignedToUser.fullName}`;
  return appUser ? prependUserToSelectNote(`\r\n ${updateAssigneeNote}`, appUser.name) : updateAssigneeNote;
};

export const addLedgerNote = async (ledgerName: string, note: string): Promise<void> => {
  await axios.post("/proxy/api/ledgers/addLedgerNote", { ledgerName, note });
};

export const updateLedgerAssignee = async (ledgerName: string, assignedToUser: InternalUser): Promise<void> => {
  const cleanedUserName = cleanUserName(assignedToUser.username);
  await axios.post("/proxy/api/ledgers/updateLedgerAssignedTo", { ledgerName, userName: cleanedUserName });
};

export const saveLedgerAssignTo = async (
  ledgerName: string,
  assignedToUser: InternalUser,
  appUser: User | null
): Promise<void> => {
  const note = createAssignmentNote(assignedToUser, appUser);
  await addLedgerNote(ledgerName, note);
  await updateLedgerAssignee(ledgerName, assignedToUser);
};
